module.exports = __webpack_public_path__ + "img/search_focus.497a520.png";